import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface User {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
  azureAccountId?: string; // Azure Entra ID account identifier
  tenantId?: string; // Azure tenant ID
  theme?: "light" | "dark"; // User's theme preference from backend
}

export interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  loading: boolean;
  error: string | null;
  accessToken: string | null;
  rehydrated?: boolean;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  loading: false,
  error: null,
  accessToken: null,
  rehydrated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<User>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.isAuthenticated = false;
      state.user = null;
      state.loading = false;
      state.error = action.payload;
      state.accessToken = null;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    clearAccessToken: (state) => {
      state.accessToken = null;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.loading = false;
      state.error = null;
      state.accessToken = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("persist/REHYDRATE", (state: AuthState) => {
      state.rehydrated = true;
    });
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  setAccessToken,
  clearAccessToken,
  logout,
  clearError,
} = authSlice.actions;

export default authSlice.reducer;
